module.exports = __webpack_public_path__ + "img/express-splitter-north.166cf7fd.png";